<template>
  <div class="finishStat">
    <div class="pk-top">
      <p class="title"><span>屏1：全员排名</span></p>
      <div class="pk-top-right">
        <el-date-picker :picker-options="pickerOptions" v-model="time_select" value-format="yyyy-MM-dd" type="date" placeholder="选择日期" @change="timeChange()">
        </el-date-picker>
        <p class="small">*数据每十秒钟更新一次</p>
      </div>
    </div>
    <div class="main-box" v-show="tableData.length>0">
      <div class="topChart">
        <div class="fl">
          <div class="rankBackground" v-if="stuRankData.length>0">
            <span class="second" v-if="stuRankData[1]" v-text="stuRankData[1].xsxm?stuRankData[1].xsxm:'暂无'"></span>
            <span class="second" v-else>暂无</span>
            <span class="first" v-if="stuRankData[0]" v-text="stuRankData[0].xsxm?stuRankData[0].xsxm:'暂无'"></span>
            <span class="first" v-else>暂无</span>
            <span class="third" v-if="stuRankData[2]" v-text="stuRankData[2].xsxm?stuRankData[2].xsxm:'暂无'"></span>
            <span class="third" v-else>暂无</span>
          </div>
        </div>
        <!-- <div class="fl">
        <p style="text-align:center;font-size:18px;">班级历史平均词汇量</p>
        <div id="finishStat" :style="{margin:'0 auto',width: '100%', height: '300px'}"></div>
      </div> -->
      </div>
      <div class="bottomChart">
        <el-table stripe :data="tableData" height="calc(100% - 50px)">
          <el-table-column width="100" label="排名" :index="indexMethod" type="index">
          </el-table-column>
          <el-table-column property="xsxm" label="姓名">
          </el-table-column>
          <el-table-column property="bjmc" label="常规班">
          </el-table-column>
          <el-table-column property="xb" label="性别">
            <template slot-scope="scope">
              <div v-if="scope.row.xb==1"> <i class="el-icon-male" style="color:#67C23A;font-size:18px"></i> 男 </div>
              <div v-else-if="scope.row.xb==2"> <i class="el-icon-female" style="color:#F56C6C;font-size:18px"></i> 女 </div>
              <div v-else>未知</div>
            </template>
          </el-table-column>
          <!-- curClassChl 当前课次所有词汇 -->
          <el-table-column property="curClassYzwchl" label="当天所有课次词汇量">
          </el-table-column>
          <!-- zchl 总词汇量 -->
          <el-table-column property="zchl" label="总词汇量">
          </el-table-column>
          <!--curClassYzwchl 当前课次已掌握  -->
          <el-table-column property="curFinishNum" label="当前词汇量进度" width="260px">
            <template slot-scope="scope">
              <el-progress :stroke-width="8" :percentage="formatPercentage(scope.row.yxdygs,scope.row.zdygs)*100" :format="function(){return null}" :color="customColorMethod"></el-progress>
            </template>
          </el-table-column>
        </el-table>
<!--        <div class="tea-pagination">-->
<!--          <el-pagination @size-change="handleSizeChange" background @current-change="handleCurrentChange" :current-page="pages.currentPage" :page-sizes="[10, 20, 30, 40]" :page-size="pages.pageSize" layout="total, sizes, prev, pager, next, jumper" :total="pages.total">-->
<!--          </el-pagination>-->
<!--        </div>-->
      </div>
    </div>
    <div class="empty">
      <el-empty description="暂无数据" class="" v-show="tableData.length==0"></el-empty>
    </div>
  </div>
</template>

<script>
import { screenAllStudentRankingApi } from '@/api/teacher.js'
export default {
  name: 'finishStat',
  data() {
    return {
      search_data: {
        yhid: this.$store.state.userInfo.yhid,
        zhid: this.$store.state.userInfo.zhid,
        bjid: this.$route.query.bjid,
        bjmc: this.$route.query.bjmc,
      },
      pages: {
        currentPage: 1,
        pageSize: 100,
        total: 0,
      },
      tableData: [],
      stuRankData: [],
      pickerOptions: {
        disabledDate: (time) => {
          return this.dealDisabledDate(time)
        }
      },
      time_select: null,//当前时间
      time_section: [],//可选择时间区间
      timeFirst: null,
    }
  },
  created() {
    const time_options = JSON.parse(this.$route.query.time)
    this.time_section = [time_options.yxqq, time_options.yxqz];
    this.time_select = time_options.now_select;
    this.timeFirst = JSON.parse(decodeURIComponent(this.$route.query.timeFirst));
    console.log(this.timeFirst)
  },
  mounted() {
    this.getAllStudentRank()
    this.setTimer()
  },
  distroyed: function () {
    clearInterval(this.setTimer())
  },
  methods: {
    // 日期禁选
    dealDisabledDate(time) {
      let start = new Date(this.$utils.getNowTime(0, 0, -1, this.time_section[0])).getTime();
      let now = new Date(this.$utils.getNowTime(0, 0, 0,)).getTime()
      let end = new Date(this.time_section[1]).getTime();
      if (end > now) {
        end = now
      }
      return time < start || time > end
    },
    timeChange() {
      this.handelSearch()
    },
    getAllStudentRank() {
      const data = this.search_data;
      data.currentPage = this.pages.currentPage;
      data.pageSize = this.pages.pageSize;
      data.qryDate = this.time_select;
      data.jxStartTime = this.timeFirst.yxqq;
      data.jxEndTime = this.timeFirst.yxqz;
      // data.bjrs = 4;
      console.log(data)
      screenAllStudentRankingApi(data).then(res => {
        if (res.result) {
          console.log(res.result)
          this.pages.total = res.result.total
          this.tableData = res.result.list;
          if (this.pages.currentPage == 1) {
            this.stuRankData = this.tableData
          }
        }
      })
    },
    setTimer: function () {
      this.timer = setInterval(() => {
        this.handelSearch()
      }, 10000)
    },
    indexMethod(index) {
      return (this.pages.currentPage - 1) * this.pages.pageSize + index + 1;
    },
    handleCurrentChange(val) {
      this.pages.currentPage = val;
      this.getAllStudentRank()
    },
    handleSizeChange(val) {
      this.pages.pageSize = val;
      this.handelSearch()
    },
    handelSearch() {
      this.pages.currentPage = 1;
      this.getAllStudentRank()
    },
    formatPercentage(num, all) {
      if (all && num) {
        const percentage = (Number(num) / Number(all)).toFixed(2)
        return percentage
      }
      return 0
    },
    customColorMethod(percentage) {
      if (percentage < 50) {
        return '#E86452';
      } else if (percentage < 60) {
        return '#E6A23C';
      } else if (percentage < 70) {
        return '#5B8FF9';
      } else if (percentage < 80) {
        return '#6f7ad3';
      } else if (percentage < 90) {
        return '#5AD8A6';
      } else if (percentage > 90) {
        return '#67C23A';
      }
    },
  }
}
</script>
<style lang="scss" scope>
.tea-pagination {
  margin-top: 15px;
}
.finishStat {
  width: 100%;
  height: 100%;
  padding: 0 20px;
  .pk-top {
    display: flex;
    justify-content: space-between;
    .pk-top-right {
      display: flex;
      align-items: center;
    }
    .small {
      // text-align: right;
      font-size: 12px;
      margin-right: 20px;
      color: red;
      margin-left: 20px;
    }
    .title {
      // margin: 10px auto;
      span {
        background: #309bff;
        padding: 5px 20px;
        color: #fff;
        border-radius: 18px;
      }
    }
  }
  .el-table__header {
    .has-gutter {
      th {
        background-color: #eee;
      }
    }
  }
  .el-table__body tr.el-table__row--striped td {
    background: #e1f4ff;
  }
  .main-box {
    width: 100%;
    height: calc(100% - 50px);
  }
  .bottomChart {
    width: 100%;
    margin: 0 auto;
    margin-top: 30px;
    height: calc(100% - 360px);
  }
  .topChart {
    padding: 0 20px;
    overflow: hidden;
    width: 90%;
    margin: 0 auto;
    display: flex;
    align-items: center;
    justify-content: center;
    // .fl {
    //   width: 50%;
    // }
    .rankBackground {
      margin-right: 50px;
      background: url(../../../assets/images/teacher/timg.png) no-repeat;
      background-size: 100% 100%;
      width: 389px;
      height: 191px;
      margin-top: 130px;
      span {
        font-size: 28px;
        display: inline-block;
        width: 33%;
        text-align: center;
        float: left;
        color: #666;
        padding-top: 155px;
        // text-align:right;
        background: url(../../../assets/images/teacher/first.png) no-repeat;
        background-position: 18px 0px;
        margin-top: -107px;
        padding-top: 77px;
        &.second {
          padding-top: 80px;
          margin-top: -80px;

          text-align: center;
          background: url(../../../assets/images/teacher/second.png) no-repeat;

          background-position: 17px 0px;
        }
        &.third {
          // padding-top:175px;
          margin-top: -51px;
          text-indent: 30px;
          text-align: left;
          background: url(../../../assets/images/teacher/third.png) no-repeat;
          background-position: 5px 0px;
        }
      }
    }
  }

  padding-top: 20px;
  ::v-deep  .el-table {
    margin: 20px auto 0;
    .progress {
      height: 10px;
      background: rgba(233, 233, 233, 1);
      border-radius: 20px;
      position: relative;
      span {
        position: absolute;
        left: 0;
        top: 0;
        display: inline-block;
        background: #54b2fe;
        height: 10px;
      }
    }
  }
}
.empty {
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
}
</style>
